//
import MessageBox from './src/messageBox'
import type { Action } from './src/message-box.type'

// MessageBox.install = app => {
//   app.config.globalProperties.$msgbox = _MessageBox
//   app.config.globalProperties.$messageBox = _MessageBox
//   app.config.globalProperties.$alert = _MessageBox.alert
//   app.config.globalProperties.$confirm = _MessageBox.confirm
//   app.config.globalProperties.$prompt = _MessageBox.prompt
// }

export default MessageBox
export type { Action }
